const BASE_URL = 'https://link.casinowonlink.com/api'

export async function fetchSiteData() {
  const response = await fetch(`${BASE_URL}/site`)
  if (!response.ok) {
    throw new Error('Site verileri yüklenemedi')
  }
  const json = await response.json()
  return json.data
}
